import { defineComponent as _defineComponent } from 'vue';
import DatasetHash from "@/components/DatasetInformation/DatasetHash.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetHashes',
    props: {
        hashes: null
    },
    setup(__props) {
        return { __sfc: true, DatasetHash };
    }
});
